import { DEFAULT_BANDS } from "../../utils/scoreCalculator";

export default function RatingScale({ score, bands = DEFAULT_BANDS }) {
  const sorted = [...bands].sort((a, b) => a.min - b.min);
  const has = score !== null && score !== undefined;
  return (
    <div className="rating-scale">
      <div className="rating-scale-track">
        {sorted.map((b) => (
          <span key={b.label} className={`rating-scale-band tone-${b.tone}`} style={{ width: `${Math.min(100, Number(b.max) - Number(b.min) + 0.01)}%` }} title={`${b.label}: ${b.min} to ${b.max}`} />
        ))}
        {has && <span className="rating-scale-marker" style={{ left: `${Math.min(100, Math.max(0, score))}%` }} role="img" aria-label={`Score ${score}`} />}
      </div>
      <div className="rating-scale-labels">
        {sorted.map((b) => (
          <span key={b.label} style={{ width: `${Math.min(100, Number(b.max) - Number(b.min) + 0.01)}%` }}>
            <strong>{b.label}</strong>
            <em>{b.min}+</em>
          </span>
        ))}
      </div>
    </div>
  );
}
